<template>
    <CompassModal
        v-model:visible="showDialog"
        size="small"
        class="import-cancel-dialog"
        :title="$t.__('settings.import.importCancelPopup.title')"
        :secondaryActions="secondaryAction"
        :primaryAction="primaryAction"
        @closed="$emit('closed')"
    >
        <template>
            <div class="typographies-paragraph-medium-regular">
                {{ $t.__('settings.import.importCancelPopup.description') }}
            </div>
        </template>
    </CompassModal>
</template>
<script>
import ImportService from 'api/import/importService';
export default {
    props: {
        batchId: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isLoading: false,
            showDialog: false,
        };
    },
    computed: {
        primaryAction() {
            return {
                label: this.$t.__('settings.import.importCancelPopup.confirm'),
                type: 'primary-destructive',
                loading: this.isLoading,
                action: () => this.onCancelImport(),
            };
        },
        secondaryAction() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    type: 'secondary',
                    disabled: this.isLoading,
                    action: () => this.$emit('closed'),
                },
            ];
        },
    },
    mounted() {
        this.showDialog = true;
    },
    methods: {
        onCancelImport() {
            this.isLoading = true;
            ImportService.cancelImport(this.batchId, this.type)
                .then(() => {
                    this.$pushToast({
                        type: 'success',
                        text: this.$t.__('settings.import.importCancelPopup.success'),
                        unique: true,
                    });
                    this.$emit('closed');
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$pushToast({
                        type: 'error',
                        text: this.$t.__('settings.import.importCancelPopup.error'),
                        close: true,
                        unique: true,
                    });
                });
        },
    },
};
</script>
